export default "/images/Feline.svg?d0c2225dbbc4423e02ffbdf44bc8222a";